//interface FieldTableSummaryProps = ;
import React  from 'react';
import { FieldTableSummaryRowProps, SummaryRendererCallback } from "./FieldTableTypes";

/* = {
    name: string,
    test: Function
}*/
const baseSummary: SummaryRendererCallback<any,any> = () => { return <></>; }


export function FieldTableSummaryRow<Type>(props: FieldTableSummaryRowProps<Type,any>) {
    // summary row does not allow focus..
    // summary row does not skeleton either
    const row = props.columns.map((column) => {
        if (column.exportOnly) return;
        if(column.hideWhen) {
            if(column.hideWhen({exchangeRateContext:props.exchangeRateContext}))  {
                return;
            }
        }
        let className = ' ' + (column.className ? column.className : '');
        switch (true) {
            case column.expander:
                className += ' column-expander';
                const field = <div tabIndex={-1} key={column.accessor}
                    className={'field-table__cell ' + (className ? className : '')}>
                    <div className="column-expander__inner"></div></div>;
                return field;
            case column.selector:
                className += ' column-expander';
                return <div tabIndex={-1} key={column.accessor}
                    className={'field-table__cell column-select'}
                ></div>;
            default:
                //var fieldProps = {
                //rows: props.rows
                //};
                const renderer = column.summaries && column.summaries[props.summary??''] ? column.summaries[props.summary??''] : baseSummary;
                return (<div tabIndex={-1} key={column.accessor}
                    className={'field-table__cell' + (className ? className : '')}>
                    {renderer({ rows: props.rows, currency: props.exchangeRateContext?.targetCurrency,calcExchangeRate:props.exchangeRateContext.calcExchangeRate })}
                </div>);
        }
    });
    if (props.hasDelete) {
        row.push(<div tabIndex={-1} key="delete"
            className="field-table__cell column-delete"></div>);
    }
    return <React.Fragment key={'summary-row-' + props.name}><div data-id={props.name} className={'field-table__row field-table__summary__row ' + (props.className ? props.className : '')}>{row}</div>
    </React.Fragment>;
}